import * as React from 'react';
import { cn } from './lib/cn.js';

export interface LogoProps extends React.SVGAttributes<SVGSVGElement> {
  withWordmark?: boolean;
}

export const Logo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ className, withWordmark = true, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 160 40"
      role="img"
      className={cn('h-8 w-auto text-brand-700', className)}
      {...props}
      aria-label={props['aria-label'] ?? 'Anamnia'}
    >
      <path
        d="M8 32 L18 8 L28 32 M12 24 H24"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M32 28 Q34 18 36 28 Q38 14 40 28 Q42 22 44 28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
      {withWordmark ? (
        <text
          x="52"
          y="28"
          fontFamily="'Source Serif Pro', Georgia, serif"
          fontSize="22"
          fontWeight="600"
          fill="currentColor"
        >
          anamnia
        </text>
      ) : null}
    </svg>
  ),
);
Logo.displayName = 'Logo';
